export default __webpack_public_path__ + "static/media/2_0140.9f0d4f96.webp";